module.exports = __webpack_public_path__ + "static/mobile-01-4eecd33996280bd33c3c8a4b915c8188.png";